'use strict';

import { defaultAppState } from '../App/app.states';

export const resetPasswordState = {
	name: 'resetPassword',
	url: '/reset-password-form',
	data: {
		isAnonymous: true,
	},
	component: 'resetPasswordForm',
	lazyLoad: (transition) => lazyLoadModules(transition),
	redirectTo: redirectIfSignUpDisabled,
};

export const resetPasswordVerificationState = {
	name: 'resetPasswordVerification',
	data: {
		isAnonymous: true,
	},
	component: 'resetPasswordVerification',
};

export const confirmPasswordState = {
	name: 'confirmPassword',
	url: '/reset-password',
	component: 'confirmPasswordForm',
	lazyLoad: (transition) => lazyLoadModules(transition),
	redirectTo: redirectIfSignUpDisabled,
};

async function redirectIfSignUpDisabled($transition$) {
	const authService = $transition$.injector().get('mx.shell.AuthService');
	return (await authService.isSignUpEnabled()) ? false : defaultAppState.name;
}

async function lazyLoadModules(transition) {
	const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
	const { signUpModule } = await import(/* webpackChunkName: "shell" */ './resetPassword.module');
	await $ocLazyLoad.inject({
		rerun: true,
		reconfig: true,
		name: signUpModule.name,
	});

	const { shellAgentModule } = await import('../Shell/shell');
	await $ocLazyLoad.inject(shellAgentModule.name, {}, true);
}
